// extracted by mini-css-extract-plugin
export default {"widthComboBox":"CommonVariables_widthComboBox__ju-GY","widthTextBox":"CommonVariables_widthTextBox__8wnnh"};